export const ADDRESS_ACTION_TYPE = {
  EDIT: "EDIT",
  CREATE: "CREATE",
  CLEAR: "CLEAR",
  UPDATE_ADDRESS: "UPDATE_ADDRESS",
  UPDATE_LOCATION: "UPDATE_LOCATION",
  CLOSE_FORM_MODAL: "CLOSE_FORM_MODAL",
  SUBMIT_FORM_MODAL: "SUBMIT_FORM_MODAL",
};

export const EDIT = (payload) => ({
  type: ADDRESS_ACTION_TYPE.EDIT,
  payload,
});

export const CREATE = () => ({
  type: ADDRESS_ACTION_TYPE.CREATE,
});

export const CLEAR = () => ({
  type: ADDRESS_ACTION_TYPE.CLEAR,
});

export const UPDATE_ADDRESS = (payload) => ({
  type: ADDRESS_ACTION_TYPE.UPDATE_ADDRESS,
  payload,
});

export const UPDATE_LOCATION = (payload) => ({
  type: ADDRESS_ACTION_TYPE.UPDATE_LOCATION,
  payload,
});

export const CLOSE_FORM_MODAL = () => ({
  type: ADDRESS_ACTION_TYPE.CLOSE_FORM_MODAL,
});

export const SUBMIT_FORM_MODAL = (payload) => ({
  type: ADDRESS_ACTION_TYPE.SUBMIT_FORM_MODAL,
  payload,
});
